import { Navigate, Route, Routes } from "react-router-dom";
import EntryPage from "./wizard/EntryPage";
import SendPage from "./wizard/SendPage";
import AdminApp from "./admin/AdminApp";
import NotFoundPage from "./components/NotFoundPage";

export default function App() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Routes>
        <Route path="/" element={<NotFoundPage />} />
        <Route path="/s/:entryToken" element={<EntryPage />} />
        <Route path="/send/:shipmentId" element={<SendPage />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
